import type { ReactNode } from 'react';
import { PageHeader } from '../PageHeader.tsx';

/** Page interne : en-tête (titre + intro issus du registre SEO) puis contenu dans le conteneur. */
export function PageContainer({
  path,
  split = false,
  children,
}: {
  path: string;
  /** Deux colonnes dès 1024 px (ex. départs | information trafic). */
  split?: boolean;
  children: ReactNode;
}) {
  return (
    <div className="container page">
      <PageHeader path={path} />
      <div className={split ? 'page__body page__body--split' : 'page__body'}>{children}</div>
    </div>
  );
}
